import { client, handleRequest, handleRequestBody } from "./client.ts";

export type NotificationType =
	| "comment_mention"
	| "post_comment"
	| "attendance_pending";

export interface NotificationActor {
	id: string;
	name: string;
}

export interface Notification {
	id: string;
	type: NotificationType;
	actor?: NotificationActor;
	post_id?: string;
	comment_id?: string;
	worksite_id?: string;
	reference_date?: string;
	title: string;
	read_at?: string;
	created_at: string;
}

export interface ListNotificationsParams {
	page?: number;
	pageSize?: number;
}

export interface ListNotificationsResponse {
	count: number;
	unread_count: number;
	items: Notification[];
}

export function listNotifications(
	params: ListNotificationsParams = {},
): Promise<ListNotificationsResponse> {
	return handleRequestBody(() =>
		client.get<ListNotificationsResponse>("/notifications", {
			params: {
				page: params.page,
				page_size: params.pageSize,
			},
		}),
	);
}

export async function markNotificationRead(id: string): Promise<void> {
	await handleRequest(() => client.post(`/notifications/${id}/read`));
}

export async function markAllNotificationsRead(): Promise<void> {
	await handleRequest(() => client.post("/notifications/read-all"));
}
